<template>
    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.532 23.526">
  <path fill="none" stroke="#3498db" stroke-miterlimit="10" stroke-width="1.5" d="M4.096 16.523l-3.3 3.3h0a3.449 3.449 0 002.907 2.907h0L13.83 12.613l4.12.195 4.673-4.673-1.524-3.138L17.22 8.87l-1.283-1.285L14.65 6.3l3.877-3.871L15.394.908 10.72 5.581l.195 4.119-2.757 2.761"/>
</svg>
</template>